<template>
  	<u-animate-container>
		<div class="contatcs">
			<div class="container-fluid pb-5 container-top">
				<div class="container p-0">
					<b-row>
						<b-col cols="12" class="text-center pt-5 mt-5 p-0">
				    		<h1 class="section-title">{{configs['contacts_title']}}</h1>
							<b-col md="8" offset-md="2">
								<p v-html="configs['contacts_txt']"></p>
							</b-col>
						</b-col>
					</b-row>
				</div>
			</div>
			<div class="container content position-relative space-to-footer">
				<u-animate
			      name="fadeInUp"
				  :offset="0"
				  delay="0s" 
			      duration="1.2"
				  :begin="true" 
			      :iteration="1"
			    >
				    <b-row>
						<b-col md="4" class="text-center text-md-left position-relative">
							<div class="details pl-3">
								<h5 class="section-title mb-0">{{configs['address']}}</h5>
								<p>
									Av. Fontes Pereira de Melo, 14 - 7º,
									<br>
									1050-121 Lisboa - Portugal
								</p>
								<h5 class="section-title mb-0">{{configs['phone']}}</h5>
								<p><a href="callto:+351213184800">+351 21 318 48 00</a></p>
								<h5 class="section-title mb-0">FAX</h5>
								<p>+351 21 357 22 60</p>
								<h5 class="section-title mb-0">EMAIL</h5>
								<p class="mb-0"><a class="email" href="mailto:sonagi@sonagi.pt">sonagi@sonagi.pt</a></p>
							</div>
						</b-col>
						<b-col md="8" class="mt-4 mt-md-0">
							<div class="map_overline"></div>
							<div id="map">
								
							</div>
						</b-col>
					</b-row>
				</u-animate>
			</div>
			<Footer></Footer>
		</div>
    </u-animate-container>
</template>
<script>
import init_map from '@/js/g_map.js';
export default {
    name: 'contacts',
	mounted: function() {
		init_map();
	}
}
</script>
<style scoped>
.container-top {
	background-image: url('../assets/images/002Fundo_Contactos.jpg');
}
.details {
	bottom: 0;
	position: absolute;
	left: 0;
	line-height: 20px;
}
#map {
	height: 400px;
}
.map_overline {
	height: 5px;
	background-color: #00263d;
}
.details a {
	color: #00263d;
}
.details a:hover {
	text-decoration: underline;
}
@media screen and (max-width:767.98px) {
	.details {
		position: static;
	}
}
</style>